import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { DateTime } from 'luxon';
import { useSnackbar } from 'notistack';
import { Button, CircularProgress } from '@mui/material';
import SmallHeader from '../Van/singleVanPage/SmallHeader';
import Footer from 'src/components/Footer';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import './styles.scss';

const ClientPage: FC = () => {
  const { getClient, payNow } = useActions();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const {
    client: { orderList, isLoading, result },
  } = useTypedSelector((state) => state);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const { id } = jwtDecode(token!) as { [key: string]: any };
    getClient(id);
  }, [token]);

  useEffect(() => {
    result.pay === 200 && (
      enqueueSnackbar('Payment was successful', {
        variant: 'success',
      })
    );
  }, [result.pay]);

  return (
    <>
      <div className='header'>
        <SmallHeader />
      </div>
      <div className='client'>
        {isLoading.get ? (
          <div className='loading-container'>
            <CircularProgress size={100} />
          </div>
        ) : (
          <>
            {orderList ? (
              <div className='client__orders'>
                {orderList.map((order) => (
                  <div className='client__order'>
                    <h4>Order #{order.id}</h4>
                    <div className='client__order__container'>
                      <div className='client__order__info'>
                        <h5>
                          <b>Booked:</b>
                          {
                            DateTime.fromISO(order.created_at, { zone: "UTC" })
                              .plus({ minutes: order.timeOffset }).toFormat("ff")
                          }
                        </h5>
                        <h5>
                          <b>From:</b>
                          {
                            `${DateTime.fromISO(order.start_date, { zone: "UTC" })
                              .plus({ minutes: order.timeOffset }).toFormat("ff")} 
                            | ${order.location} ${order.sub_location ? ` | ${order.sub_location}` : ''
                            }`
                          }
                        </h5>
                        <h5>
                          <b>To:</b>
                          {
                            `${DateTime.fromISO(order.end_date, { zone: "UTC" })
                              .plus({ minutes: order.timeOffset }).toFormat("ff")} 
                            | ${order.end_location || order.location} ${order.sub_location_end ? ` | ${order.sub_location_end}` : ''
                            }`
                          }
                        </h5>
                        <h5>
                          <b>Host Email:</b>{order.van?.host.email}
                        </h5>
                      </div>
                      <div className='client__order__actions'>
                        <Button
                          onClick={() => payNow(order.id)}
                          children={isLoading.pay ? <CircularProgress size={15} /> : 'Pay Now'}
                        />
                        <Button
                          onClick={() => navigate(`/driver/add/${order.inviteDriverHash}`)}
                          children='Invite Drivers'
                        />
                        <Button
                          onClick={() => navigate(`/license/${order.licenseHash}`)}
                          children='Upload DL'
                        />
                        <Button
                          onClick={() => navigate(`/contract/${order.signRaHash}`)}
                          children='Sign RA'
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : null}
          </>
        )}
      </div>
      <div className='footer'>
        <Footer />
      </div>
    </>
  );
};

export default ClientPage;
